<template>
  <v-layout align-start>
    <v-flex>
      <!-- Tabs-->
      <div v-if="TablaVisible">
        <template>
          <v-form>
            <v-container grid-list-sm class="pa-4 white">
              <v-row>
                <v-col cols="12" md="12" class="py-0">
                  <v-alert
                    type="success"
                    class="subtitle-2 text-center"
                    color="primary"
                    >Captura de Creditos</v-alert
                  >
                </v-col>

                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="creditofecha"
                        label="Fecha del Flete"
                        prepend-icon="event"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="creditofecha"
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-text-field
                    v-model="clienteid"
                    label="Cliente"
                    outlined
                    type="number"
                    @keyup.enter="clientebusca()"
                    @keydown.tab="clientebusca()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="py-0">
                  <v-text-field
                    v-model="clientenombre"
                    label="Nombre"
                    outlined
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-select
                    v-model="creditoovale"
                    :items="creditovaleselect"
                    label="Tipo de Crdeito"
                    outlined
                  ></v-select>
                </v-col>
                
                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-text-field
                    v-model="creditovale"
                    label="Vale"
                    outlined
                    type="number"
                  ></v-text-field>
                </v-col>


                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-text-field
                    v-model="creditoticket"
                    label="Ticket"
                    outlined
                  ></v-text-field>
                </v-col>

               

                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-text-field
                    v-model="creditofactura"
                    label="Numero de Factura"
                    outlined
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-select
                    v-model="combustibleid"
                    :items="combustibleselect"
                    label="Tipo de Combustible a Cargar"
                    outlined
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-text-field
                    v-model="creditolitros"
                    label="Litros"
                    outlined
                    type="number"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-text-field
                    v-model="creditounidad"
                    label="Unidad o Vehiculo"
                    outlined
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-text-field
                    v-model="creditoimporte"
                    label="Importe"
                    outlined
                    type="number"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12" class="py-0">
                  <v-text-field
                    v-model="creditoautorizaocarga"
                    label="Nombre de Quien Autorizo o Realizo la Carga"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>

              <div align="center" justify="center">
                <v-col cols="12" md="12" align="center" justify="center">
                  <label>
                    Carga El Documento
                    <input
                      type="file"
                      id="file"
                      ref="file"
                      accept="image/jpeg, image/png, .pdf"
                      v-on:change="handleFileUpload()"
                    />
                  </label>
                </v-col>

                <div class="my-2">
                  <v-btn color="secondary" @click="close">Cancelar</v-btn>
                  <v-btn
                    color="primary"
                    @click="guardar"
                    v-if="guardarvisiblesino == 0"
                    >Guardar</v-btn
                  >
                </div>

                <v-card max-width="1200" class="mx-auto">
                  <v-list-item>
                    <v-list-item-avatar color="grey"></v-list-item-avatar>
                    <v-list-item-content align="center" justify="center">
                      <v-list-item-title class="headline"
                        >Visualizando el Documento</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>

                  <v-col
                    cols="12"
                    md="12"
                    align="center"
                    justify="center"
                    v-if="imagenopdf == 1"
                  >
                    <v-img :src="imagePreview"></v-img>
                  </v-col>

                  <v-col cols="12" md="12" v-if="imagenopdf == 2">
                    <iframe
                      :src="pdfPreview"
                      width="100%"
                      height="1020px"
                      class="embed-responsive-item"
                    ></iframe>
                  </v-col>

                  <v-card-text align="center" justify="center"
                    >Antes de Guardar el Documento Verifique que sea el
                    Correcto</v-card-text
                  >
                </v-card>
              </div>
            </v-container>
          </v-form>
        </template>
      </div>

      <v-app id="inspire" v-if="TablaVisible == 0">
        <v-card max-width="1200">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6" class="py-0">
                <v-dialog
                  ref="dialog1"
                  v-model="modal1"
                  :return-value.sync="fecha1"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fecha1"
                      :readonly="fecha1 == 1"
                      label="Fecha de Inicio"
                      prepend-icon="event"
                      v-bind="attrs"
                      v-on="on"
                      solo
                      @click="listar()"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fecha1"
                    scrollable
                    locale="es-es"
                    :readonly="fecha1 == 1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal1 = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog1.save(fecha1), listar()"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>

              <v-col cols="12" md="6" class="py-0">
                <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="fecha2"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fecha2"
                      :readonly="fecha2 == 1"
                      label="Fecha Fin"
                      prepend-icon="event"
                      v-on="on"
                      solo
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fecha2"
                    scrollable
                    locale="es-es"
                    :readonly="fecha2 == 1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog.save(fecha2), listar()"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>
          </v-container>

          <v-container>
            <v-toolbar color="primary" dark>
              <v-icon>savings</v-icon>
              <v-spacer></v-spacer>

              <v-toolbar-title>Relacion de Creditos a Capturar</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn icon @click="mostrarNuevo()">
                <v-icon>add</v-icon>
              </v-btn>
            </v-toolbar>
          </v-container>

          <v-list three-line>
            <template v-for="item in creditoselect">
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon class="grey lighten-1" dark>
                    account_balance
                  </v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    v-html="item.clientenombre"
                  ></v-list-item-title>
                  <v-list-item-subtitle class="text"
                    ><span class="text--primary">Fecha:</span>
                    {{ item.movimientofecha }}</v-list-item-subtitle
                  >
                  <v-list-item-subtitle class="text"
                    ><span class="text--primary">Importe:</span>
                    {{ item.movimientoimporte }}</v-list-item-subtitle
                  >
                  <v-list-item-subtitle class="text"
                    ><span class="text--primary">Vale:</span>
                    {{ item.credito }}</v-list-item-subtitle
                  >
                </v-list-item-content>

                <v-list-item-action>
                  <v-row>
                    <v-btn icon>
                      <v-icon color="grey lighten-1" @click="editar(item)"
                        >edit</v-icon
                      >
                    </v-btn>
                    <v-btn icon>
                      <v-icon color="grey lighten-1" @click="eliminar(item)"
                        >delete</v-icon
                      >
                    </v-btn>
                  </v-row>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
      </v-app>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import VueExcelXlsx from "vue-excel-xlsx";
import { StreamBarcodeReader } from "vue-barcode-reader";

export default {
  components: {
    StreamBarcodeReader,
  },
  data() {
    return {
      guardarvisible: 0,
      TablaVisible: 0,
      fletefecha: moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      fecha1: moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      fecha2: moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      modal: false,
      modal1: false,
      menu: false,
      modal: false,
      clienteid: "",
      clientenombre: "",
      clienteselect: [],
      creditofecha: "",
      clienteid: "",
      creditoimporte: "",
      creditoticket: "",
      creditovale: "",
      combustibleid: "",
      combustibleselect: [],
      creditofactura: 0,
      //
      pdfPreview: "",
      imagenopdf: 0,

      options: {
        locale: "en-US",
        prefix: "$",
        suffix: "",
        length: 11,
        precision: 2,
      },

      creditoselect: [],
      guardarvisiblesino: 0,
      guardarditasino: 0,
      //
      movimientoid: "",
      liquidacionid: "",
      servicioid: "",
      file: "",
      //
      text: "",
      id: null,
      //
      creditolitros: "",
      creditounidad: "",
      creditoautorizaocarga: "",
      creditoovale: 1,
      creditovaleselect: [
        { text: "CREDITO", value: 1 },
        { text: "CREDITO VALE", value: 2 },
      ],
    };
  },
  // Crea una nueva categoria si es -1
  computed: {},

  props: {
    msg: String,
  },

  watch: {},

  created() {
    this.selectgasolinatipo();
    this.listar();
  },

  //
  methods: {
    onDecode(a, b, c) {
      console.log(a, b, c);
      this.text = a;
      if (this.id) clearTimeout(this.id);
      this.id = setTimeout(() => {
        if (this.text === a) {
          this.text = "";
        }
      }, 5000);
    },
    onLoaded() {
      console.log("load");
    },

    /* captura ticket 
      <div class="hello">
                  <StreamBarcodeReader
                    @decode="(a, b, c) => onDecode(a, b, c)"
                    @loaded="() => onLoaded()"
                  ></StreamBarcodeReader>
                  Input Value: {{ text || "Nothing" }}
                </div>
    */

    getHumanDate: function(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    mostrarNuevo() {
      this.TablaVisible = 1;
      this.guardarvisiblesino = 0;
      this.limpiar();
    },

    ocultarNuevo() {
      this.TablaVisible = 0;
      this.limpiar();
    },

    getColor(socioestatus) {
      if (socioestatus == 1) return "yellow";
      if (socioestatus == 3) return "#DA0707";
    },

    guardar() {
      if (this.clienteid == "" || this.clienteid === null) {
        this.$swal("No se a Especificado el Cliente");
        return;
      }

      if (this.creditoticket == "" || this.creditoticket === null) {
        this.$swal("No se a Especificado el Ticket");
        return;
      }

      if (this.combustibleid == "" || this.combustibleid === null) {
        this.$swal("No se a Especificado el Tipo de Combustible");
        return;
      }

      if (this.creditolitros == "" || this.creditolitros === null) {
        this.$swal("No se a Especificado los Litros");
        return;
      }

      if (this.creditounidad == "" || this.creditounidad === null) {
        this.$swal("No se a Especificado la Unidad o Vehiculo");
        return;
      }

      if (this.creditoimporte == "" || this.creditoimporte === null) {
        this.$swal("No se a Especificado el Importe");
        return;
      }

      if (
        this.creditoautorizaocarga == "" ||
        this.creditoautorizaocarga === null
      ) {
        this.$swal("No se a Especificado Quien Cargo o Autorizo");
        return;
      }

      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;

      let formData = new FormData();

      formData.append("clienteid", me.clienteid);
      formData.append("combustibleid", me.combustibleid);
      formData.append("creditoimporte", me.creditoimporte);
      formData.append("creditofecha", me.creditofecha);
      formData.append("creditoticket", me.creditoticket);
      formData.append("creditovale", me.creditovale);
      formData.append("creditofactura", me.creditofactura);
      formData.append(
        "creditousuariocaptura",
        me.$store.state.usuario.usuarioid
      );
      formData.append("file0", me.file);
      formData.append("movimientoid", me.movimientoid);
      formData.append("liquidacionid", me.liquidacionid);
      formData.append("servicioid", me.servicioid);
      formData.append("creditolitros", me.creditolitros);
      formData.append("creditounidad", me.creditounidad);
      formData.append("creditoautorizaocarga", me.creditoautorizaocarga);
      formData.append("creditovaleocupon", me.creditoovale);

      axios
        .post("api/creditos/crear", formData, configuracion)
        .then(function(response) {
          me.limpiar();
          me.listar();
          me.TablaVisible = 0;
          me.$swal("Flete Capturado con Exito");
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("Error al de Captura del Algun Dato");
          }
        });
    },

    clientebusca() {
      let me = this;
      var listaArray = [];
      var nombre = "";
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/clientes/listarid/" + me.clienteid)
        .then(function(response) {
          me.$swal("Cliente: " + response.data.cliente.clientenombre);
          me.clientenombre = response.data.cliente.clientenombre;
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("El Cliente No Existe");
            me.clienteigas = "";
          }
        });
    },

    close() {
      this.TablaVisible = 0;
      this.fleteexcel = 0;
    },

    listar() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      axios
        .get(
          "api/movimientos/creditopordias/" + me.fecha1 + "/" + me.fecha2,
          configuracion
        )
        .then(function(response) {
          me.creditoselect = response.data.credito;
        })
        .catch(function(error) {
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    selectgasolinatipo() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/combustibles/listarcombustibles", configuracion)
        .then(function(response) {
          listaArray = response.data.combustible;
          listaArray.map(function(x) {
            me.combustibleselect.push({
              text: x.combustiblenombre,
              value: x.combustibleid,
            });
          });
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    handleFileUpload() {
      /*
                Set the local file variable to what the user has selected.
              */
      this.file = this.$refs.file.files[0];

      /*
                Initialize a File Reader object
              */
      let reader = new FileReader();

      /*
                Add an event listener to the reader that when the file
                has been loaded, we flag the show preview as true and set the
                image to be what was read from the reader.
              */
      reader.addEventListener(
        "load",
        function() {
          if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
            this.imagenopdf = 1;
            this.extencion = 1;
            this.showPreview = true;
            this.imagePreview = reader.result;
          }

          if (/\.(pdf)$/i.test(this.file.name)) {
            this.imagenopdf = 2;
            this.extencion = 2;
            this.showPreview = true;
            this.pdfPreview = reader.result;
          }
        }.bind(this),
        false
      );

      /*
                Check to see if the file is not empty.
              */
      if (this.file) {
        /*
                    Ensure the file is an image file.
                  */
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
        if (/\.(pdf)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },

    ver(item) {
      this.TablaVisible = 1;
      this.guardarvisiblesino = 1;
      this.guardarditasino = 0;
      this.creditofecha = item.movimientofecha;
      this.clienteid = item.clienteigas;
      this.clientenombre = item.clientenombre;
      this.creditovale = item.credito;
      this.creditoimporte = item.movimientoimporte;
      this.movimientoid = item.movimientoid;
      this.liquidacionid = item.liquidacionid;
      this.servicioid = item.servicioid;
      this.creditoticket = item.creditoticket;
      this.combustibleid = item.combustibleid;
      this.creditolitros = item.creditolitros;
      this.creditounidad = item.creditounidad;
      this.creditoautorizaocarga = item.creditoautorizaocarga;
      this.creditovale = item.creditovale;
    },

    editar(item) {
      this.TablaVisible = 1;
      this.guardarvisiblesino = 0;
      this.guardarditasino = 1;
      this.creditofecha = item.movimientofecha;
      this.clienteid = item.clienteigas;
      this.clientenombre = item.clientenombre;
      this.creditovale = item.credito;
      this.creditoimporte = item.movimientoimporte;
      this.movimientoid = item.movimientoid;
      this.liquidacionid = item.liquidacionid;
      this.servicioid = item.servicioid;
      this.creditoticket = item.creditoticket;
      this.combustibleid = item.combustibleid;
      this.creditolitros = item.creditolitros;
      this.creditounidad = item.creditounidad;
      this.creditoautorizaocarga = item.creditoautorizaocarga;
      this.creditoovale = item.creditovale;
    },

    eliminar(item) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      // Actualiza

      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Eliminar",
        text:
          "El Flete: " + item.fleteid + " Numero de Factura: " + item.facturaid,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
      }).then((result) => {
        if (result.value) {
          axios
            .put(
              "api/creditos/eliminar",
              {
                movimientoid: item.movimientoid,
                liquidacionid: item.liquidacionid,
                movimientofecha: item.movimientofecha,
              },
              configuracion
            )
            .then(function(response) {
              me.botonver = 1;
              me.limpiar();
              me.listar();
              me.$swal("Eliminado", "Se a Eliminado con Exito", "success");
              me.close();
            })
            .catch(function(error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();
                me.$swal("No se a Eliminado Checar");
              }
            });
        }
      });
    },

    limpiar() {
      (this.creditofecha = moment(
        this.$store.state.usuario.fecha,
        "YYYY-MM-DD"
      ).format("YYYY-MM-DD")),
        (this.clienteid = "");
      this.clientenombre = "";
      this.combustibleid = "";
      this.creditoimporte = "";
      this.creditoticket = "";
      this.creditovale = "";
      this.creditofactura = 0;
      this.file = "";
      this.movimientoid = "";
      this.liquidacionid = "";
      this.servicioid = "";
      this.creditolitros = "";
      this.creditounidad = "";
      this.creditoautorizaocarga = "";
    },
  },
};
</script>
